import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({ request: z.uuid().optional().catch(undefined) });

/**
 * `/hr/approvals` moved to the unified inbox `/approvals` (T-074); older notification links
 * keep working and still open their request.
 */
export const Route = createFileRoute('/_app/hr/approvals')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/approvals',
      search: search.request ? { request: search.request } : {},
      replace: true,
    });
  },
});
